import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { setThemeMode } from '@store/app/actions';
import { selectThemeMode } from '@store/app/selectors';
import { useAppDispatch } from '@store/hooks';
import { ThemeModes } from '@themes/enums';

import { ICONS_TYPES } from '../Icon';

import { Props } from './types';
import { Root, ThemeIcon } from './styles';

const ThemeSwitcher: FC<Props> = ({ className }) => {
  const dispatch = useAppDispatch();
  const themeMode = useSelector(selectThemeMode);

  const handleSwitchTheme = useCallback(() => {
    const selectedTheme =
      ThemeModes.light === themeMode ? ThemeModes.dark : ThemeModes.light;
    dispatch(setThemeMode({ mode: selectedTheme }));
  }, [dispatch, themeMode]);

  return (
    <Root className={className} onClick={handleSwitchTheme}>
      {ThemeModes.light === themeMode ? (
        <ThemeIcon icon={ICONS_TYPES.Sun} size={24} />
      ) : (
        <ThemeIcon icon={ICONS_TYPES.Moon} size={24} />
      )}
    </Root>
  );
};

export default ThemeSwitcher;
